// Re-render once a second, and say what time the SERVER thinks it is. Lifted
// from the Andon app's `useTick`.
//
// One interval per component that needs it; React batches the renders, and
// the alternative — a global ticker in the store — re-renders screens that
// have no clock on them at all.
//
// Returns the server's current time, corrected for device drift (the skew the
// session slice measured at boot), because a tablet whose clock is four
// minutes fast must not report a breach that has not happened.

import { useEffect, useState } from 'react';
import { useStore } from '@/store';

export function useTick(enabled = true): number {
  const skew = useStore((s) => s.serverSkewMs);
  const [, setBeat] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    const id = setInterval(() => setBeat((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, [enabled]);

  return Date.now() - skew;
}
